import { PERMISSIONS } from './permissions.js';

/**
 * Permission keys that gate the Groups screens (CT-5572), all from the shared catalog. Create and
 * delete are their own keys, not role checks (Oct 5 ~49:00). contract TBD (ARP/backend): the real
 * key names are not defined. Owner and Admin pass every key through the guard (Admin default for
 * delete pending Thomas).
 */
export const GROUP_PERMISSIONS = Object.freeze({
  VIEW: PERMISSIONS.GROUPS_VIEW,
  CREATE: PERMISSIONS.GROUPS_CREATE,
  MANAGE: PERMISSIONS.GROUPS_MANAGE,
  DELETE: PERMISSIONS.GROUPS_DELETE,
});
